import { getDataBrokerDeletionStats } from './api'

const createDeletionData = (deletionData) => ({
  dataBrokersRemoved: deletionData?.dataBrokersRemoved ?? null,
  totalDataBrokers: deletionData?.totalDataBrokers ?? null,
})

export const getReklaimProtectDeletionData = async (userAlias) => {
  let deletionData
  try {
    deletionData = await getDataBrokerDeletionStats(userAlias)
  } catch (error) {
    deletionData = null
  }
  return createDeletionData(deletionData)
}
